import { Model, Attr } from 'spraypaint';
import ApplicationRecord from '../ApplicationRecord';

@Model()
export default class BookingTypeStats extends ApplicationRecord {
  static jsonapiType = 'booking-type-stats';

  static listHeaders() {
    return [
      {
        text: 'ID',
        value: 'id',
        width: 100,
        sortable: false,
      },
    ];
  }

  static scopeFactory() {
    return BookingTypeStats.includes([]);
  }

  @Attr() startDatetime: string;
  @Attr() endDatetime: string;
  @Attr() stats: { [key: string]: number };
}
